module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk og engelsk_primaerlogo_pos(svart).258b7a7d.pdf";